import { DocumentData } from "@1games-ru/region-shared/dist/types/documents/documentData";
import clsx from "clsx";

export default function WeaponLicense({ docNumber, owner, expiresAt }: DocumentData) {
  return (
    <div
      className={clsx(
        "w-[28.75rem] h-[19.125rem] flex flex-col p-[1.875rem] ",
        "text-15 text-[#373A2F] font-medium",
      )}
      style={{
        backgroundImage: "url(./svg/documents/weapon-license.webp)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <div className="pl-[4.5rem] italic text-left">
        РАЗРЕШЕНИЕ НА ХРАНЕНИЕ И НОШЕНИЕ
        <br /> ОГНЕСТРЕЛЬНОГО ОРУЖИЯ
      </div>
      <div className="w-full flex items-start gap-5 mt-[1.5rem]">
        <div className="relative shrink-0 bg-white">
          <img
            src={owner.photo}
            alt=""
            className="w-[7.5rem] h-[8.75rem] border border-[#373A2F] pointer-events-none"
          />
          <div
            className="absolute -top-[0.3rem] left-0 right-0  h-[0.625rem]"
            style={{
              backgroundImage: "url(./svg/documents/green-photo-border-g.svg)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
            }}
          />
          <div
            className="absolute -top-[0.3rem] -left-[0.25rem] h-[6.25rem] w-[0.625rem]"
            style={{
              backgroundImage: "url(./svg/documents/green-photo-border-v.svg)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
            }}
          />
        </div>
        <div className="flex flex-col gap-4 grow">
          <div>
            <div className="text-14 uppercase">{[owner.lastName, owner.firstName].join(" ")}</div>
            <div className="text-dark-800 mt-0.5">Имя Фамилия</div>
          </div>
          <div>
            <div className="text-14 uppercase">{owner.dateOfBirth}</div>
            <div className="text-dark-800 mt-0.5">Дата рождения</div>
          </div>
          <div>
            <div className="text-14 uppercase">{expiresAt || "-"}</div>
            <div className="text-dark-800 mt-0.5">Срок действия</div>
          </div>
        </div>
      </div>
      <div className="mt-auto flex items-end justify-between">
        <div className="text-dark-800">№ {docNumber}</div>
        <div className="relative w-[9.5rem] border-b border-[#373A2F]">
          <img
            src="./svg/documents/seal-military.webp"
            alt=""
            className="absolute z-1 w-[6.25rem] aspect-square pointer-events-none right-0 bottom-[0.5rem] rotate-12"
          />
          {owner?.signature && (
            <div
              className="absolute z-2 h-[4rem] -bottom-[1rem] right-0"
              style={{
                backgroundImage: `url(${owner.signature})`,
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
